var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNlg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2AB0FD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3522 8.32725C14.445 8.32613 14.5041 8.3385 14.5412 8.37225C14.5806 8.40825 14.5963 8.46675 14.6048 8.55844C14.8669 11.5841 12.5786 14.319 9.5434 14.5997C6.41365 14.8894 3.69677 12.6309 3.39977 9.49219C3.11065 6.444 5.39946 3.67875 8.4544 3.40088C10.1846 3.24338 11.6786 3.78675 12.9364 4.98488C12.9493 4.99725 12.9465 5.049 12.9319 5.06363C12.6495 5.35137 12.3645 5.63657 12.0769 5.91919C12.0606 5.93494 12.0021 5.93269 11.9841 5.91638C10.6864 4.72725 9.18283 4.37513 7.53865 4.97419C5.8759 5.58 4.92471 6.83438 4.73627 8.60063C4.48315 10.9907 6.28708 13.0973 8.69346 13.2789C10.8748 13.4432 12.8515 11.8991 13.2131 9.74363C13.2165 9.72225 13.1681 9.66882 13.1434 9.66882C11.7962 9.66488 10.449 9.666 9.1024 9.66094C9.06752 9.66094 9.00283 9.59625 9.00171 9.56082C8.99464 9.18435 8.99464 8.80778 9.00171 8.43132C9.00227 8.39757 9.06246 8.33682 9.09565 8.33625C9.9934 8.33119 13.4978 8.33907 14.3516 8.32669L14.3522 8.32725Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNlg);
export default __webpack_public_path__ + "static/media/nlg.8f0b0656837faf257dcad690cd62cf18.svg";
export { ForwardRef as ReactComponent };